import {
	appendBottomSignatureRow,
	buildSignatureContentBlock,
} from '@/components/UnlayerEditorWrapper/signatureDesign/builders';
import {
	cloneDesignSnapshot,
	findHtmlTemplate,
	getSignatureBlock,
	removeSignatureArtifacts,
} from '@/components/UnlayerEditorWrapper/signatureDesign/cleanup';

// Rebuild a design so it contains exactly one signature block appended as the
// final row in the document. The helper tolerates empty starting designs because
// the compose dialog can auto-select a signature before any template is loaded.
//
// Also handles the case where content was added into a signature row.
// In that case, we remove the signature portion and leave the content alone
// This fixes an a bug (BROKERV2-1508) where creating a template in the Compose Email dialog would 
// cause the whole content do disappear when later selected due to dropping content
// directly into the default signature row
export const getUpdatedDesignWithSignature = (design, rawSignatureHtml) => {
	if (!design || typeof design !== 'object') {
		return design;
	}

	const nextDesign = cloneDesignSnapshot(design);
	if (!nextDesign.body || typeof nextDesign.body !== 'object') {
		nextDesign.body = {
			rows: [],
			values: {},
		};
	}
	if (!Array.isArray(nextDesign.body.rows)) {
		nextDesign.body.rows = [];
	}

	const rows = nextDesign.body.rows;
	removeSignatureArtifacts(rows);

	const signatureHtml = getSignatureBlock(rawSignatureHtml);
	if (!signatureHtml) {
		return nextDesign;
	}

	const { counters, signatureContent } = buildSignatureContentBlock({
		counters: nextDesign.counters ?? {},
		rawSignatureHtml: signatureHtml,
		template: findHtmlTemplate(rows),
	});
	nextDesign.counters = counters;

	appendBottomSignatureRow({
		design: nextDesign,
		rows,
		signatureContent,
	});

	return nextDesign;
};
